/** Empty leaf for SceneHub layout routes — the hub reads the URL itself. */
const SceneHubLeaf = () => null

export default SceneHubLeaf
